import React from "react";
import { MessageCircle } from "lucide-react";

export const WhatsAppFab = () => {
  return (
    <a
      href="https://wa.me/917996750556?text=Hi%20VersaCorp%2C%20I%27d%20like%20to%20know%20more%20about%20your%20products."
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-3 pr-4 py-3 rounded-full shadow-xl shadow-emerald-500/30 transition-colors">
        <MessageCircle size={20} />
        <span className="hidden sm:inline font-semibold text-sm">Chat on WhatsApp</span>
      </span>
    </a>
  );
};
